export default __webpack_public_path__ + "static/boomreader-img-b5a277356d0f71aca5ac2956c551756d.png";